module.exports = __webpack_public_path__ + "mea-icon.9472f5607d1401e648e07f852e6e3ac3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/mea-icon.svg
// module id = 1149
// module chunks = 0